// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".chart-content[data-v-130e745e],.chart-wrapper[data-v-130e745e]{height:100%;width:100%}", ""]);
// Exports
module.exports = exports;
